import React from 'react';
import superagent from 'superagent';

import MoviesTVWrapper from './MoviesTVWrapper.jsx';

import {
    Container,
    Segment,
    Grid,
    Header,
    Image,
    Icon,
    Button,
    Table,
    Form,
    Label,
    Message,
    Menu,
    Tab,
    Dropdown,
    Modal,
    Card, 
    Divider} from 'semantic-ui-react'

class Categories extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            categories: []
        };
    }

    async componentDidMount() {
        const res = await superagent.get(`/api/admin/media/categories`).accept('json');
        this.setState({ categories: res.body });
    }

    render() {
        return (
            <MoviesTVWrapper>
                <Button href={`/cinema/category`}>Create a category</Button>
                {this.state.categories.map(category => {
                    return (
                        <Segment>
                            <Header as="h3">Category: {category.title}</Header>
                            <Button href={`/cinema/category/${category.id}`}>Edit</Button>
                        </Segment>
                    )
                })}
            </MoviesTVWrapper>
        );
    }
}

export default Categories;
